import React, { Component } from "react";
import { Link } from "react-router-dom";

import NumberFormat from 'react-number-format';

import axios from "axios";
import swal from "sweetalert";
import $ from "jquery";

import { PaystackConsumer } from "react-paystack";

import Header from "./common/Header";
import Sidebar from "./common/Sidebar";

var _name_on_doc;

export class SingleLand extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: localStorage["appState"]
              ? JSON.parse(localStorage["appState"]).user.token
              : "",
            user: [],
      home: [],
      plan: "",
      home_id: "",
      payment_ref: "",
      auth_code: ""
    };
  }

  componentDidMount() {
    this.getUser();
    this.getHome();
    
  }

  getUser(){
    axios
            .get(`${axios.defaults.baseURL}/user/${JSON.parse(localStorage["appState"]).user.id}`,
            {
              headers: {
                'Authorization': `Bearer ${this.state.token}`
              }
            }
            )
            .then(response => {
              //console.log(response);
              return response;
            })
            .then(json => {
              if (json.data.success) {
                this.setState({ user: json.data.user[0] });
              // } else alert("Cannot Fetch Data!");
              } else swal("Oops!", "Cannot Fetch Data!", "error");;
            })
            .catch(error => {
              console.error(`An Error Occured! ${error}`);
            });
            // alert(id)
  }

  getHome(){

    var id = window.location.href.split("/")[
      window.location.href.split("/").length - 1
    ];
    axios
      .get(`${axios.defaults.baseURL}/view-land/${id}`)
      .then((response) => {
        //console.log(response);
        return response;
      })
      .then((json) => {
        if (json.data.success) {
          this.setState({
            home: json.data.home,
            plan: json.data.home[0].initial,
            // plan: json.data.home[0].plan_code,
            home_id: json.data.home[0].id,
          });
        } else {
          //console.log(`Cannot fetch data!`);
        }
      })
      .catch((error) => {
        console.error(`An Error Occured! ${error}`);
      });
  }

  tAndC(event) {
    swal(
      "Terms & Conditions!",
      "Once you subscribe for any plan, you will be required to activate your bank card for automatic debit of plan amount based on your type of plan. Your subscription shall be for a maximum period of Seven (7) years commencing from the date we receive the first installment. You are at liberty to subscribe at different times within the payment window. Each subscription shall be treated separately and the delivery date calculated from the date we receive the first installment."
    );
  }

  totalPayment(initial, installment, duration){
    var multipliedValue = installment * duration;
    if (initial == installment) {
    return Number(installment) * Number(duration);
    }else{
    return Number(initial) + Number(multipliedValue);
    }
  }

  render() {
    const configNGN = {
      // reference: (new Date()).getTime(),
      email: this.state.user.email,
      // plan: this.state.plan,
      amount: this.state.plan+"00",
      currency: "NGN",
      publicKey: 'pk_live_68d2b6e9edacd11392f5548db9047ffb4911b39d',
      // publicKey: "pk_test_3a1c9194d014f2629abda6e0c3f22cb931141cf4",
    };

    const componentPropsNGN = {
      ...configNGN,
      text: "Plan Payment Activation",
      onSuccess: (response) => {

        // console.log(response);

        this.setState({
          payment_ref: response.trxref
        });

        axios({
            method: 'get',
            url: `https://api.paystack.co/transaction/verify/${this.state.payment_ref}`,
            headers: {'Authorization': `Bearer sk_live_5299c2d2e25663425657490251d1cec7d8c206aa`, 'Content-Type': 'application/json' }
            // headers: {'Authorization': `Bearer sk_test_2e3a16e2c572cbcfd59cbc761105f58b7a34e90d`, 'Content-Type': 'application/json' }
            })
            .then(response => {
                //console.log(response);
                return response;
            })
            .then(json => {
                  this.setState({
                    auth_code: json.data.data.authorization.authorization_code
                  });

                  swal("Success!", "Payment Plan Activation was Successful!", "success", {
                    button: false,
                    timer: 1500,
                  });
          
                  var formData = new FormData();
                  formData.append("name_on_doc", _name_on_doc.value);
                  formData.append("home_id", this.state.home_id);
                  formData.append("auth_code", this.state.auth_code);
                  formData.append("user_id", JSON.parse(localStorage["appState"]).user.id);
          
                  axios({
                      method: 'post',
                      url: `${axios.defaults.baseURL}/subscribe-land`,
                      data: formData,
                      headers: {'Authorization': `Bearer ${JSON.parse(localStorage["appState"]).user.token}`, 'Content-Type': 'multipart/form-data' }
                      })
                      .then(response => {
                          //console.log(response);
                          return response;
                      })
                      .then(json => {
                          if (json.data.success) {
                            // swal("Success!", "" + json.data.message, "success", {
                            //   button: false,
                            //   timer: 1500,
                            // });
                          // redirect to plans
                          this.props.history.push("/my-plans");
                          } else {
                          swal("Failed", ""+ json.data.message, "error");
                          }
                      })
                      .catch(error => {
                          // alert("An Error Occured!" + error);
                          let res = ("An Error Occured");
                          swal("Error!", "" + res, "error", {
                          button: false,
                          // timer: 1500
                          });
                          //console.log(`${formData} ${error}`);
                      });
            });
      },
      onClose: () => null,
    };

    $("#name_on_doc-input").attr("value", this.state.user.fname + " " + this.state.user.lname);

    return (
      <div id="app" className="bg-gray-200">
        <div className="dashboard-page">
          <div className="private-layout">
            <div className="app-wrapper">
              <Sidebar />
              <Header />
              <div id="main-app" className="position-relative">
                <div className="container mt-4">
                  <Link to="/landvest">
                    <i className="ti-arrow-left"></i> Back to Lands Listing
                  </Link>
                  {this.state.home.map((home) => (
                    <div key={home.id}>
                      <div className="page-title">
                        <div className="row text-primary py-2">
                          <div className="col-12">
                            <div
                              className="user-welcome"
                              style={{ overflow: "hidden" }}
                            >
                              <div className="wrapper d-flex">
                                <h4 className="d-inline-block titlecase">
                                  {home.name} - <NumberFormat value={home.price} displayType={'text'} thousandSeparator={true} prefix={'₦'} /> {home.type} Installment Plan
                                </h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-8 mt-4">
                          <img
                            src={home.image}
                            className="plan-img-view"
                            alt=""
                          />
                            <div className="mt-4 mb-4">
                              <h5>Type of plan:</h5>
                              <p className="text-secondary">
                                {home.type} installment
                              </p>
                              <h5>Duration:</h5>
                              <p className="text-secondary">
                                {home.duration} {home.type == "monthly"
                                  ? "Months"
                                  : home.type == "weekly"
                                  ? "Weeks"
                                  : null}
                              </p>
                              <h5>Total Payment:</h5>
                              <p className="text-secondary">
                                <NumberFormat value={this.totalPayment(home.initial, home.price, home.duration)} displayType={'text'} thousandSeparator={true} prefix={'₦'} />
                              </p>
                              <h5>Initial Deposit:</h5>
                              <p className="text-secondary">
                                <NumberFormat value={home.initial} displayType={'text'} thousandSeparator={true} prefix={'₦'} />
                              </p>
                              <h5>Installmental Payments:</h5>
                              <p className="text-secondary">
                                <NumberFormat value={home.price} displayType={'text'} thousandSeparator={true} prefix={'₦'} />
                              </p>
                              <h5>Description:</h5>
                              <p className="text-secondary">
                                {home.description}
                              </p>
                            </div>
                        </div>
                        
                        <div className="col-md-4 mt-4">
                              <h5 className="text-primary">Start Plan 🚀</h5>
                          <form>
                            <div>
                              {/* <fieldset className="form-group">
                                <div className="form-row">
                                  <div
                                    tabindex="-1"
                                    role="group"
                                    className="bv-no-focus-ring col"
                                  >
                                    <select
                                      id="type"
                                      type="text"
                                      required="required"
                                      aria-required="true"
                                      className="form-control"
                                    >
                                      <option value="">How many Rooms?</option>
                                      <option value="1 Bedroom Apartment">
                                        1 Bedroom Apartment
                                      </option>
                                      <option value="2 Bedroom Apartment">
                                        2 Bedroom Apartment
                                      </option>
                                      <option value="3 Bedroom Apartment">
                                        3 Bedroom Apartment
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </fieldset> */}
                              <fieldset className="form-group">
                                <div className="form-row">
                                  <legend
                                    tabindex="-1"
                                    className="bv-no-focus-ring col-form-label"
                                  >
                                    Preferred Name on Document
                                  </legend>
                                  <div
                                    tabindex="-1"
                                    role="group"
                                    className="bv-no-focus-ring col"
                                  >
                                    <input
                                      ref={(input) => (_name_on_doc = input)}
                                      id="name_on_doc-input"
                                      name="name_on_doc"
                                      type="text"
                                      required="required"
                                      aria-required="true"
                                      className="form-control"
                                    />
                                  </div>
                                </div>
                              </fieldset>
                              {/* <fieldset className="form-group">
                                <div className="form-row">
                                  <legend
                                    tabindex="-1"
                                    className="bv-no-focus-ring col-form-label"
                                  >
                                    Number of Units
                                  </legend>
                                  <div
                                    tabindex="-1"
                                    role="group"
                                    className="bv-no-focus-ring col"
                                  >
                                    <select
                                      id="type"
                                      type="text"
                                      required="required"
                                      aria-required="true"
                                      className="form-control"
                                    >
                                      <option value="1">1</option>
                                      <option value="2">2</option>
                                      <option value="3">3</option>
                                      <option value="4">4</option>
                                      <option value="5">5</option>
                                      <option value="6">6</option>
                                      <option value="7">7</option>
                                      <option value="8">8</option>
                                      <option value="9">9</option>
                                      <option value="10">10</option>
                                    </select>
                                  </div>
                                </div>
                              </fieldset> */}
                              <div className="text-center">
                                {/* <button
                                  id="stateful-button"
                                  type="submit"
                                  className="btn btn-primary my-4"
                                >
                                  <span
                                    aria-hidden="true"
                                    className="spinner-border spinner-border-sm"
                                    style={{ display: "none" }}
                                  ></span>{" "}
                                  Start Payment of {home.type} Installment
                                </button> */}
                                <PaystackConsumer {...componentPropsNGN}>
                                  {({ initializePayment }) => (
                                    home.status == "active" ? (
                                      <button
                                    type="button"
                                      onClick={() =>
                                        swal(
                                          "You are about to activate a "+ "₦" + `${home.price}` + " " +
                                            `${home.type}` +
                                            " payment plan for " +
                                            `${home.name}`,
                                          {
                                            buttons: {
                                              cancel: "No, Cancel",
                                              catch: {
                                                text: "Yes, Continue",
                                                value: "catch",
                                              },
                                            },
                                          }
                                        ).then((value) => {
                                          switch (value) {
                                            case "catch":
                                              initializePayment();
                                              break;

                                            default:
                                          }
                                        })
                                      }
                                      id="submit"
                                      name="subscribe-button"
                                      className="btn btn-primary my-4"
                                    >
                                      Start Payment of {home.type} Installment
                                    </button>
                                  ) : home.status == "soldout"  ? (<input type="button" className="btn w-100 btn-warning" value="Sold Out" disabled/>) : null
                                  )}
                                </PaystackConsumer>
                                <Link
                                  className="btn btn-dark my-4"
                                  onClick={this.tAndC}
                                >
                                  Read Terms & Conditions
                                </Link>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SingleLand;
